import { graphql } from "@opensea/graphql"
import { TreasureRewardMediaFragment } from "./TreasureRewardMedia.fragment"

export const TreasureRewardCardFragment = graphql(
  `
    fragment TreasureRewardCard on Badge {
      id
      name
      description
      ...TreasureRewardMedia
    }
  `,
  [TreasureRewardMediaFragment],
)
